import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CategoryFilters from '../components/CategoryFilters';
import PropertyCard from '../components/PropertyCard';
import heroVilla from '../assets/images/villa.png';
import { fetchCategories } from '../apis/categories';
import {
  fetchProperties,
  fetchPropertiesByCategory
} from '../apis/properties';
import { normalizeProperty } from '../utils/property';

function HomePage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [categories, setCategories] = useState(['All']);
  const [categoryLookup, setCategoryLookup] = useState({});
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    fetchCategories(controller.signal)
      .then((data) => {
        const remoteNames = data.map((category) => category.name);
        const lookup = data.reduce((acc, category) => {
          acc[category.name] = category.id;
          return acc;
        }, {});

        setCategories(['All', ...remoteNames]);
        setCategoryLookup(lookup);
      })
      .catch((error) => {
        console.error('Unable to load categories', error);
      });

    return () => controller.abort();
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    async function loadProperties() {
      try {
        const categoryId = categoryLookup[activeCategory];
        const data =
          activeCategory !== 'All' && categoryId
            ? await fetchPropertiesByCategory(categoryId, controller.signal)
            : await fetchProperties(controller.signal);

        setProperties(
          data.map((property) => normalizeProperty(property, heroVilla))
        );
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Unable to load properties', error);
        }
      }
    }

    loadProperties();

    return () => controller.abort();
  }, [activeCategory, categoryLookup]);
  
  return (
    <div className="home-page">
      <Header />

      {/* HERO SECTION */}
      <div className="hero-container">
        <img src={heroVilla} alt="hero background" className="hero-background" />
        <div className="hero-overlay"></div>

        <div className="hero-content-wrapper">
          <section className="hero-section">
            <div className="hero-text">
              <h1>Your home should tell your story</h1>
            
            </div>
          </section>

          <div className="hero-categories">
            <CategoryFilters
              categories={categories}
              activeCategory={activeCategory}
              setActiveCategory={setActiveCategory}
            />
          </div>
        </div>
      </div>
  
      {/* MAIN CONTENT */}
      <main className="home-content">
       
  
        <section className="properties-section">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </section>
      </main>
  
      <Footer />
    </div>
  );
  
}

export default HomePage;
